<div id="header_container" class="header-container">
  <app-citizen-header-extern></app-citizen-header-extern>
</div>

<div id="content_container" class="content-container">
  <router-outlet></router-outlet>
</div>

<div class="footer-container">
  <app-citizen-footer-extern id="footer_container" class="footer prime-bg-color-1 prime-fg-color-2"></app-citizen-footer-extern>
</div>